// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import LoadingController from "./loading_controller"
application.register("loading", LoadingController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import CatalogNavController from "./catalog_nav_controller"
application.register("catalog-nav", CatalogNavController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ExternalRedirectController from "./external_redirect_controller"
application.register("external-redirect", ExternalRedirectController)

import DepositFormController from "./deposit_form_controller"
application.register("deposit-form", DepositFormController)

import DebouncedSubmitController from "./debounced_submit_controller"
application.register("debounced-submit", DebouncedSubmitController)

import NoticeModalController from "./notice_modal_controller"
application.register("notice-modal", NoticeModalController)

import CouponNoticeModalController from "./coupon_notice_modal_controller"
application.register("coupon-notice-modal", CouponNoticeModalController)

import CarouselController from "./carousel_controller"
application.register("carousel", CarouselController)

import PolymarketFeedController from "./polymarket_feed_controller"
application.register("polymarket-feed", PolymarketFeedController)

import SupportChatController from "./support_chat_controller"
application.register("support-chat", SupportChatController)
